import { useLogger } from "@agportal/logger";
import { createRestClient } from "@dmvs/client";
import { strict as assert } from "assert";

export default class StazeniObsahuPspService {
    constructor(url) {
        assert(url, "url has to be specified");

        this.logger = useLogger();
        this.rest = createRestClient({
            baseURL: url,
        });
    }

    async stahniObsahPsp(url) {
        const response = await fetch(url);

        this.logger.debug(
            "StazeniObsahuPspService.stahniObsahPsp for url {0} returns {1}",
            url,
            response
        );

        return response.status >= 200 && response.status < 300 ? await response.blob() : null;
    }
}
